export enum OrganizationRole {
    User = 'User',
    Administrator = 'Administrator'
}
